import { createSelector, Selector } from 'reselect';
import { State } from '../../../store/reducers';
import { selectNotifications } from '../notifications.selector';
import { projectIsValid } from '../../../domain/checks/project/projectIsValid';

export const selectProjectIsValid: Selector<State, boolean> = createSelector(
  [selectNotifications],
  (notifications): boolean => projectIsValid(notifications)
);
